import axios from '../config.js';
const resource = '/case/examination';

export default {
  create(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.post(resource, payload);
  },
  // get(id='') {
  //   axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
  //   return axios.get(`${resource}${id ? `/${id}`: ''}`);
  // },
  // update(id='', payload) {
  //   axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
  //   return axios.put(`${resource}/${id}`, payload);
  // }
};